import _slicedToArray from "/drone/src/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useEffect } from 'react';
import { RESIZE_OBSERVER_SUPPORTED } from '../../Table/TableExpandableSection/constants';
import { BUFFER_TAGS_WIDTH, SINGLE_LINE_MAX_ALLOWED_HEIGHT } from '../constants';
export var useOnPopulateTagsAutomatically = function useOnPopulateTagsAutomatically(selectedTagsToDisplay, beforeSectionContainerRef, beforeSectionWrapperRef, isMaxWidthReached, setIsMaxWidthReached, internalOpenTagsCount, setInternalOpenTagsCount, singleLine) {
  return useEffect(function () {
    var observer = null;

    if (RESIZE_OBSERVER_SUPPORTED && singleLine && beforeSectionContainerRef.current) {
      observer = new ResizeObserver(function (entries) {
        var _entries = _slicedToArray(entries, 2),
            tagContainer = _entries[0],
            tagWrapper = _entries[1];

        if (!tagContainer || !tagWrapper) {
          return;
        }

        var _tagContainer$target$ = tagContainer.target.getBoundingClientRect(),
            containerNodeWidth = _tagContainer$target$.width;

        var _tagWrapper$target$ge = tagWrapper.target.getBoundingClientRect(),
            wrapperNodeWidth = _tagWrapper$target$ge.width,
            wrapperNodeHeight = _tagWrapper$target$ge.height;

        var cumulativeMaxWidth = wrapperNodeWidth + BUFFER_TAGS_WIDTH * 2;

        if (!isMaxWidthReached && cumulativeMaxWidth <= containerNodeWidth) {
          setInternalOpenTagsCount(internalOpenTagsCount + 1);
        } else if (!isMaxWidthReached && cumulativeMaxWidth > containerNodeWidth || wrapperNodeHeight > SINGLE_LINE_MAX_ALLOWED_HEIGHT) {
          setIsMaxWidthReached(true);
          setInternalOpenTagsCount(internalOpenTagsCount - 1);
        }

        if (!isMaxWidthReached && cumulativeMaxWidth > containerNodeWidth) {
          setIsMaxWidthReached(true);
        }
      });
      observer.observe(beforeSectionContainerRef.current);
      observer.observe(beforeSectionWrapperRef.current);
    }

    return function () {
      if (observer) {
        observer.disconnect();
      }
    };
  }, [selectedTagsToDisplay.length, internalOpenTagsCount, isMaxWidthReached, singleLine]);
};